module.exports = __webpack_public_path__ + "static/media/1242-x-2208-i-os-09-3-x-copy.2c2246b5.png";